import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @atlaskit/editor/no-re-export */
// Entry file in package.json

import { editorExperimentsConfig } from './experiments-config';
import { testBooleanOverrides, testMultivariateOverrides } from './exp-test-overrides';
export var _overrides = {};
export var _paramOverrides = {};
export var _product;

/**
 * This function is used to set up the editor experiments for testing purposes.
 * It should be called before running code that depends on editor experiments.
 *
 * @example
 * ```ts
 * setupEditorExperiments('confluence', {
 *  'experiment-name': 'value',
 * });
 * ```
 */
export function setupEditorExperiments(product,
/**
 * Overrides are used to set the group of an experiment for testing purposes.
 * This is useful when you want to test a specific experiment group.
 */
groupOverrides,
/**
 * Param overrides are used to set the experiment parameters for testing purposes.
 * This is useful when you want to tweak the experiment parameters for testing.
 */
paramOverrides, options) {
  if (groupOverrides) {
    // When setting up overrides, we want to ensure that experiments don't end up with invalid
    // values.
    // For production usage -- this is done via the feature flag client which takes the type
    // and performs equivalent logic.
    // @ts-ignore
    groupOverrides = Object.entries(groupOverrides).reduce(function (acc, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      var config = editorExperimentsConfig[key];
      if (config) {
        acc = _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, config.typeGuard(value) ? value : config.defaultValue));
      }
      return acc;
    }, {});
    _overrides = groupOverrides;
  }
  if (product === 'test' && !(options !== null && options !== void 0 && options.disableTestOverrides)) {
    // Enforce expectation - file overrides, then global overrides, then default to true for boolean
    // experiments, then last result use the default value
    var testOverrides = Object.fromEntries(Object.entries(editorExperimentsConfig).map(function (_ref3) {
      var _ref5, _ref6, _groupOverrides, _groupOverrides2;
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];
      var defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
      return [key, (_ref5 = (_ref6 = (_groupOverrides = (_groupOverrides2 = groupOverrides) === null || _groupOverrides2 === void 0 ? void 0 : _groupOverrides2[key]) !== null && _groupOverrides !== void 0 ? _groupOverrides : testMultivariateOverrides[key]) !== null && _ref6 !== void 0 ? _ref6 : testBooleanOverrides[key]) !== null && _ref5 !== void 0 ? _ref5 : defaultValue];
    }));
    _overrides = testOverrides;
  }
  _product = product;
  _paramOverrides = paramOverrides || {};
}